import 'css-chunksrc/client/scenes/project/secondaryCriteria/budgetSection/styles.scss';export default {
  "budgetContainer": "_budgetContainer_15rus_1",
  "budgetGroup": "_budgetGroup_15rus_7",
  "groupTitle": "_groupTitle_15rus_13",
  "groupRows": "_groupRows_15rus_21",
  "budgetRow": "_budgetRow_15rus_27",
  "budgetLabel": "_budgetLabel_15rus_48",
  "totalLabel": "_totalLabel_15rus_59",
  "icon": "_icon_15rus_65",
  "group": "_group_15rus_13",
  "input": "_input_15rus_78",
  "value": "_value_15rus_101",
  "totalValue": "_totalValue_15rus_110",
  "warning": "_warning_15rus_120",
  "positive": "_positive_15rus_124"
};